import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class EmailService {

    constructor(private http: HttpClient) {}

    enviaEmail(params) {
        return this.http.post('http://gpocircuitos.provisorio.ws/php/email.php', {
            params: params
        });
    }
}